import gql from 'graphql-tag'

export const GET_DEPARTMENT = gql`
  query CompanyStructures($filter: GetCompanyStructuresInput) {
    companyStructures(filter: $filter) {
      isSuccessful
      message
      companyStructures {
        data {
          structureId
          companyId
          parentId
          name
          level
          isPosition
          hasRelation
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const DEPARTMENT_MUTATION_CREATE = gql`
  mutation CreateCompanyStructure($input: CreateCompanyStructureInput!) {
    createCompanyStructure(input: $input) {
      isSuccessful
      message
      companyStructure {
        structureId
        companyId
        parentId
        name
        level
        isPosition
      }
    }
  }
`

export const DEPARTMENT_MUTATION_UPDATE = gql`
  mutation UpdateCompanyStructure($input: UpdateCompanyStructureInput!) {
    updateCompanyStructure(input: $input) {
      isSuccessful
      message
      companyStructure {
        structureId
        companyId
        parentId
        name
        level
        isPosition
      }
    }
  }
`

export const DEPARTMENT_MUTATION_DELETE = gql`
  mutation DeleteCompanyStructure($input: GetCompanyStructureInput!) {
    deleteCompanyStructure(input: $input) {
      isSuccessful
      message
    }
  }
`
